











import { Vue, Component } from "vue-property-decorator";
import moment from "moment";
import { useImportantDateStore } from "@/shared/store/importantDate";
import { Watch } from "@/shared/vuepack";
import { FetchState, ImportantDateRequest } from "@/shared/types";


@Component({})
export default class ImportantDateBanner extends Vue {
  importantDateStore = useImportantDateStore();

  mounted () {
    const dateRequest: ImportantDateRequest = {
      startDate: moment().startOf("day").toDate(),
      count: 3
    };
    this.importantDateStore.getImportantDateList(dateRequest);
  }
  get importantDates () {
    return this.importantDateStore.importantDates;
  }

  formatDate (date: string) {
    if (!date) {
      return "";
    }

    return moment(date).format("MMM D");
  }
}
